<div class="share-order-wrapper">
  <div class="share-order-container">
    <button mat-icon-button [matTooltip]="'CALC_PAGE.PRINT_VERSION' | translate" (click)="share('print')">
      <mat-icon>print</mat-icon>
    </button>
    <button mat-icon-button [matTooltip]="'CALC_PAGE.SAVE_PDF' | translate" (click)="share('savePdf')">
      <mat-icon svgIcon="fi_pdf"></mat-icon>
    </button>
    <button mat-icon-button [matTooltip]="'CALC_PAGE.SHARE_WHATSAPP' | translate" (click)="share('whatsapp')">
      <mat-icon svgIcon="fi_whatsapp"></mat-icon>
    </button>
    <button mat-icon-button [matTooltip]="'CALC_PAGE.SHARE_EMAIL' | translate" (click)="share('email')">
      <mat-icon svgIcon="fi_email"></mat-icon>
    </button>
  </div>
</div>
